// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';
import './swiper.scss';

const sliders = document.querySelectorAll('.common_slide');

// それぞれのスライダーに対して初期化
sliders.forEach((slider, index) => {
  new Swiper(slider, {
    // 既存の設定
    spaceBetween: 8,
    loopAdditionalSlides: 1,
    slidesPerView: 'auto',
    loop: true,
    grabCursor: true,

    autoplay: {
      delay: 3500 + index * 500, // インデックスに応じて遅延時間を増やす
      disableOnInteraction: false,
    },

    speed: 1200,

    // その他の設定は同じ
    pagination: {
      el: `.index_news-pagination-${index}`, // ページネーションのクラスも区別する必要があります
      clickable: true,
    },
    navigation: {
      nextEl: `.index_news-button-next-${index}`, // ナビゲーションのクラスも区別する必要があります
      prevEl: `.index_news-button-prev-${index}`,
    },
    breakpoints: {
      976: {
        centeredSlides: false,
      },
      0: {
        centeredSlides: true,
      },
    },
  });
});
